'use client';

import ProductCard from '@/features/product-card/components/productCard';
import data from '../../../../../public/json/popular-product.json';
import { useState } from 'react';

const ShopProducts = () => {
  const [products, setProducts] = useState([
    ...data.slice(0, 8),
    ...data.slice(0, 4),
  ]);
  return (
    <div className="col-lg-9">
      <div className="row row-cols-xl-4  row-cols-md-3 row-cols-2 row-cols-1 justify-content-center g-3">
        {products?.length > 0 &&
          products.map((product: any, i: number) => (
            <div className="col" key={i}>
              <ProductCard key={i} data={product} />
            </div>
          ))}
      </div>
      <div className="product-btn text-center mt-5">
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => setProducts([...products, ...data.slice(0, 4)])}
          className="about__btn trk-btn trk-btn--primary"
        >
          View More
        </a>
      </div>
    </div>
  );
};

export default ShopProducts;
